import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StatistiqueComponent } from '../admin-app/statistique/statistique.component';
import { ImportComponent } from '../admin-app/import/import.component';
import { LoginComponent } from '../admin-app/login/login.component';
import { SouscripteurComponent } from '../admin-app/souscripteurs/souscripteur.component';
import { Ng2FileUploadComponent } from '../admin-app/ng2file/ng2file-upload.component';
import { NgFileComponent } from '../admin-app/ngfile/ngfile.component';
import { TabComponent } from '../client-app/tab/tab.component';
import { AuthComponent } from '../client-app/auth/auth.component';
import { SignupComponent } from '../client-app/signup/signup.component';
import { MainComponent } from '../client-app/main/main.component';
import { ValidateComponent } from '../client-app/validate/validate.component';
import { PasswordComponent } from '../client-app/password/password.component';


const routes: Routes = [
    { path: 'admin/import', component: ImportComponent },
    { path: 'admin/statistique', component: StatistiqueComponent },
    { path: 'admin/login', component: LoginComponent },
    { path : '', component : AuthComponent },
    { path : 'admin/souscripteurs', component : SouscripteurComponent },
    { path : 'admin/ng2file', component : Ng2FileUploadComponent },
    { path : 'admin/ngfile', component : NgFileComponent },
    { path : 'signup', component : SignupComponent },
    { path : 'login', component : AuthComponent },
    { path : 'main', component : MainComponent },
    { path : 'tab', component : TabComponent },
    { path : 'validation', component : ValidateComponent },
    { path : 'password', component : PasswordComponent }

    
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ],
    declarations: []
})

export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/core/app.routing.module.ts